import { ApiService } from "@/api";

export const updateTelpIntvSampleNote = (sampleId: string, note: string) => {
  return ApiService.baseAction(
    `sample-telephone-interview/note/${sampleId}`,
    {
      data: {
        note,
      },
    },
    "post"
  );
};
